import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ITimeZoneList } from 'src/app/models/ITimeZoneList';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { IStates } from 'src/app/models/IStates';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { IAttributes } from 'src/app/models/IAttributes';
import { IManageERx } from 'src/app/models/IManageERx';
import { IStateList } from 'src/app/models/IStateList';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { IrxProvider } from 'src/app/models/IrxProvider';
import { IEnabledProvides } from 'src/app/models/IEnabledProviders';
import { IProviderDirectoryRequestDTO } from 'src/app/models/IProviderDirectoryRequestDTO';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { configuration } from 'src/environments/environment';



export interface PeriodicElement {
  providername: string;
  npi: string;
  servicelevel: string;
  speciality: string;
  location: string;
}

@Component({
  selector: 'app-manage-erx',
  templateUrl: './manage-erx.component.html',
  styleUrls: ['./manage-erx.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageErxComponent implements OnInit {

  columnsToDisplay = ['providerName', 'npi', 'serviceLevel', 'state', 'locationName'];
  headercolumnsToDisplay = ['Provider Name', 'NPI', 'Service Level', 'State', 'Location'];
  // displayedColumnss: string[] = ['state', 'statelicenseno', 'deano', 'rxstatequalifierno', 'Action'];
  displayedColumnss: string[] = ['stateName', 'stateLicNumber', 'dea', 'stateQualifier', 'Action'];
  dataSources: any;
  displayedColumnsse: string[] = ['spi', 'locationname', 'adrslin1', 'adrslin2', 'city', 'state', 'zip', 'Action'];
  dataSourcess: any;

  displayedColumnss1: string[] = ['state', 'statelicenseno', 'deano', 'rxstatequalifierno', 'Action'];
  loadStateListProvider: IStateList[] = [];
  dataSources1 = new MatTableDataSource(this.loadStateListProvider);

  // public lstStateQualifier: IStateQualifierRx[] = [];

  displayedColumnss2: string[] = ['spi', 'locationname', 'adrslin1', 'adrslin2', 'city', 'state', 'zip', 'Action'];
  //dataSourcess2 = ELEMENT_DATA;
  existingProviderLocations: ILocationDetails[] = [];
  dataSourcess2 = new MatTableDataSource(this.existingProviderLocations);
  expandedElement: PeriodicElement | null;
  timeZones: ITimeZoneList[] = [];

  toppings = new FormControl();
  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];


  public show: boolean = false;


  showInfo() {
    this.isedit = false;
    this.isDeanoReadonly = true;
    this.isstatelicensenoreadonly = true;
    this.isRxstatequlifiednoreadonly = true;
    // this.popupVisible = true;
    this.show = !this.show;
    this.clearValues();
    this.clearStateValues();
  }


  manageerxform: FormGroup;
  submitted = false;
  public lstProviders: IUserDetails[];
  public lstLocations: ILocationDetails[];
  public lstStates: IStates[];
  public lstStatesCode: IStates[];
  public lstattrbutes: IAttributes[];
  public lstServiceLevel: IAttributes[];
  public lstSpeciality: IAttributes[];
  public providerData: IUserDetails[];
  public locationData: ILocationDetails[];
  public locationProviderData: ILocationDetails[];
  public manageErx: IManageERx;
  public loadStateList: IStateList[] = [];

  public loadLocationList: ILocationDetails[] = [];
  public ILocation: ILocationDetails;
  public loadstate: IStateList;
  public statesData: IStates[];
  public irxProviderRequest: IrxProvider;
  public irxAddLocationProviderRequest: IrxProvider;
  public lstEnabledproviders: IEnabledProvides[] = [];
  public lstProviderDirectoryRequestDTO: IProviderDirectoryRequestDTO[] = [];
  dataSource23 = new MatTableDataSource(this.lstEnabledproviders);
  statelistDisable: boolean = false;
  locationListDisable: boolean = false;
  statelistDisable1: boolean = false;
  locationListDisable1: boolean = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  providerNameFilter = new FormControl('');
  npiFilter = new FormControl('');
  serviceLevelFilter = new FormControl('');
  stateFilter = new FormControl('');
  locationNameFilter = new FormControl('');
  filterValues = {
    providerName: '', npi: '', serviceLevel: '', state: '', locationName: ''
  };
  constructor(private formBuilder: FormBuilder, private sharedService: SharedService, private toastr: ToastrService, private schedulerservice: SchedularServiceService, private rxService: RxService, private dialog: MatDialog) { }


  ngOnInit() {
    this.dataSource23.paginator = this.paginator;
    this.manageerxform = this.formBuilder.group({
      selprovider: ['', Validators.required],
      mname: ['',],
      lname: ['',],
      prename: ['',],
      sufname: ['',],
      sellevel: ['', Validators.required],
      spi: ['',],
      npinum: ['', Validators.required],
      npilocation: ['',],
      medicarnum: ['',],
      speciality: ['',],
      clname: ['',],
      upin: ['',],
      adrsline1: ['', Validators.required],
      adrsline2: ['',],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      email: ['',],
      phn: [''],
      fax: [''],
      enablepres: ['',],
      strtdate: ['', Validators.required],
      starttime: ['',],
      enddate: ['', Validators.required],
      endtime: ['',],
      statee: ['',],
      statelnum: ['',],
      deanum: ['',],
      rxstatenum: ['',],
      sellocatn: ['', Validators.required],
      selproviders: ['',],
      mnames: ['',],
      lnames: ['',],
      prenames: ['',],
      sufnames: ['',],
      sellevels: ['',],
      spii: ['',],
      npinumbr: ['',],
      npilocations: ['',],
      medicarnumbr: ['',],
      specialitys: ['',],
      clnames: ['',],
      upinn: ['',],
      adrslinee1: ['',],
      adrslinee2: ['',],
      cityy: ['',],
      states: ['',],
      zipp: ['',],
      phnn: ['',],
      faxx: ['',],
      enableprescrp: ['',],
      strtdates: ['',],
      starttimes: ['',],
      enddates: ['',],
      endtimes: ['',],
      statess: ['',],
      statelnumb: ['',],
      deanumb: ['',],
      rxstatenumb: ['',],
      sellocatnn: ['',],
      dataSources: [],
      nadeanno: [''],
      SSN: [''],
      nadeanno2: [''],
      SSN2: [''],
      rxdirectaddress: [''],
      rxdirectaddresss: ['']
      //dataSources1:[],
    });
    this.onload();
    this.irxProviderRequest = {
      dddto: this.manageErx,
      states: this.loadStateList
    };
    this.irxAddLocationProviderRequest = {
      dddto: this.manageErx,
      states: this.loadStateListProvider
    };
    this.manageErx = {
      accountId: "",
      portalId: "",
      backupPortalId: "",
      messageId: "",
      spi: "",
      dea: "",
      stateLicenseNumber: "",
      specialtyCodePrimary: "",
      prefixName: "",
      lastName: "",
      firstName: "",
      middleName: "",
      suffixName: "",
      clinicName: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      standardizedAddressLine1: "",
      standardizedAddressLine2: "",
      standardizedCity: "",
      standardizedState: "",
      standardizedZip: "",
      phonePrimary: "",
      fax: "",
      email: "",
      alternatePhoneNumbers: "",
      activeStartTime: "",
      activeEndTime: "",
      serviceLevel: "",
      partnerAccount: "",
      lastModifiedDate: "",
      recordChange: "",
      oldServiceLevel: "",
      version: "",
      npi: "",
      npiLocation: "",
      specialtyType: "",
      fileId: "",
      medicareNumber: "",
      medicaIdNumber: "",
      dentistLicenseNumber: "",
      upin: "",
      ppoNumber: "",
      socialSecurity: "",
      priorAuthorization: "",
      mutuallyDefined: "",
      inStoreNCPDPId: "",
      directAddress: "",
      useCases: "",
      availableRoutes: "",
      organizationId: "",
      latitude: "",
      longitude: "",
      precise: "",
      specialtyQualifier: "",
      mode: "",
      createdBy: "",
      createdOn: "",
      modifiedBy: "",
      modifiedOn: "",
      userId: "",
      activeStatus: "",
      defaultLocationServicelevl: "",
      specialityName: "",
      qualifier: "",
      speciltyCode: "",
      details: "",
      locationId: "",
      stateQualifier: "",
      stateId: "",
      operation: "",
      nadeanNo: "",
    };

    this.providerNameFilter.valueChanges
      .subscribe(providername => {
        this.filterValues.providerName = providername;
        this.dataSource23.filter = JSON.stringify(this.filterValues);
      })
    this.npiFilter.valueChanges
      .subscribe(npi => {
        this.filterValues.npi = npi;
        this.dataSource23.filter = JSON.stringify(this.filterValues);
      })
    this.serviceLevelFilter.valueChanges
      .subscribe(servicelevel => {
        this.filterValues.serviceLevel = servicelevel;
        this.dataSource23.filter = JSON.stringify(this.filterValues);
      })
    this.stateFilter.valueChanges
      .subscribe(statee => {
        this.filterValues.state = statee;
        this.dataSource23.filter = JSON.stringify(this.filterValues);
      })
    this.locationNameFilter.valueChanges
      .subscribe(location => {
        this.filterValues.locationName = location;
        this.dataSource23.filter = JSON.stringify(this.filterValues);
      })
  }
  onload() {
    // this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
    //   this.lstProviders = data;
    // });
    this.sharedService.getAllUsersByRoleWithOutLocId("Doctor").subscribe(data => {
      this.lstProviders = data;
    });

    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
    });
    this.rxService.getAllStates().subscribe(data => {
      this.lstStates = data;
    });
    this.sharedService.getAttributes().subscribe(data => {
      this.lstattrbutes = data;
      this.sharedService.lstattrbutes = this.lstattrbutes;
      this.lstServiceLevel = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '60' && attr.isActive == true);
      this.lstSpeciality = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '61');
    });
    // this.rxService.EnabledProvidersTService().subscribe(data => {
    //   this.lstEnabledproviders = data;
    //   this.dataSource23.data = this.lstEnabledproviders;
    // });
    this.getssrequireddata();
  }
  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (data.providerName === null ? "" : data.providerName).toString().toLowerCase().indexOf(searchTerms.providerName) !== -1
        && (data.npi === null ? "" : data.npi).toString().toLowerCase().indexOf(searchTerms.npi.toLowerCase()) !== -1
        && (data.serviceLevel === null ? "" : data.serviceLevel).toString().toLowerCase().indexOf(searchTerms.serviceLevel.toLowerCase()) !== -1
        && (data.state === null ? "" : data.state).toString().toLowerCase().indexOf(searchTerms.state.toLowerCase()) !== -1
        && (data.locationName === null ? "" : data.locationName).toString().toLowerCase().indexOf(searchTerms.locationName.toLowerCase()) !== -1
        ;

    }
    return filterFunction;
  }
  async getssrequireddata() {
    await this.rxService.SurescriptsProvidersTService().subscribe(data => {
      this.lstEnabledproviders = data;
      this.dataSource23.data = this.lstEnabledproviders;
      this.dataSource23.filterPredicate = this.createFilter();
    });

  }
  get f() { return this.manageerxform.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.manageerxform.invalid) {
      return;
    }
    this.mapformValues();
    this.irxProviderRequest.dddto = this.manageErx;
    this.irxProviderRequest.states = this.loadStateList;
    this.serviceCall();
    // this.clearValues();
  }
  onClearButtonClick() {
    this.clearValues();
  }

  isdirectenabled: boolean = false;
  onProviderChange(event) {
    // alert('d')
    if (this.manageerxform.value.selprovider != '' && this.manageerxform.value.selprovider !== undefined) {
      this.providerData = this.lstProviders.filter((provd: IUserDetails) => provd.userId === this.manageerxform.value.selprovider);
      if (this.providerData.length > 0) {
        this.manageerxform.patchValue({
          lname: this.providerData[0].lastName,
          mname: this.providerData[0].firstName,
          prename: this.providerData[0].salutation,
          sufname: this.providerData[0].suffix,
          firstName: this.providerData[0].firstName,
          npinum: this.providerData[0].npiNumber,
          spi: this.providerData[0].spi,
          // city: this.providerData[0].city,
          // state: this.providerData[0].state,
          // zip: this.providerData[0].postalCode,
          // phn: this.providerData[0].phone,
          // fax: this.providerData[0].fax,
          // email: this.providerData[0].email,
          // adrsline1: this.providerData[0].address1,
          // adrsline2: this.providerData[0].address2
          rxdirectaddress: (this.providerData[0].directaddress ? this.providerData[0].directaddress.split('@')[0] : "")
        });
        if (this.providerData[0].directaddress) {
          if (this.providerData[0].directaddress != '')
            this.isdirectenabled = true;
        }
      }
      else {
        this.manageerxform.patchValue({
          lname: '',
          mname: '',
          prename: '',
          sufname: '',
          firstName: '',
          npinum: '',
          spi: ''
        });
      }
    }
    else {
      this.manageerxform.patchValue({
        lname: '',
        mname: '',
        prename: '',
        sufname: '',
        firstName: '',
        npinum: '',
        spi: ''
      });
    }
  }
  isDeanoReadonly: boolean = true;
  isstatelicensenoreadonly: boolean = true;
  isRxstatequlifiednoreadonly: boolean = true;
  onStateChange(event) {
    if (event != null) {
      this.isDeanoReadonly = false;
      this.isstatelicensenoreadonly = false;
      this.isRxstatequlifiednoreadonly = false;
    }
  }
  onChangeFormat() {
    //alert("check")
  }
  compareTwoDates() {
    if (this.manageerxform.controls['enddate'].value !== '' && this.manageerxform.controls['enddate'].value !== undefined && this.manageerxform.controls['enddate'].value !== null) {
      if (new Date(this.manageerxform.controls['enddate'].value) < new Date(this.manageerxform.controls['strtdate'].value)) {
        this.manageerxform.patchValue({
          enddate: '',
        });
        this.toastr.error('End date can\'t before start date');
      }
    }
  }
  messagedomain: string = configuration.messagedomain;
  iseRxenabled; isDMenabled;
  mapformValues() {

    this.manageErx.userId = this.manageerxform.value.selprovider;
    this.manageErx.firstName = this.manageerxform.value.mname;
    this.manageErx.middleName = "";//this.manageerxform.value.mname;
    this.manageErx.lastName = this.manageerxform.value.lname;
    this.manageErx.prefixName = this.manageerxform.value.prename;
    this.manageErx.suffixName = this.manageerxform.value.sufname;
    //this.manageErx.serviceLevel ="New";// this.manageerxform.value.sellevel.toString();
    this.manageErx.serviceLevel = this.manageerxform.value.sellevel.toString();
    this.manageErx.spi = this.manageerxform.value.spi;
    this.manageErx.npi = this.manageerxform.value.npinum;
    this.manageErx.npiLocation = this.manageerxform.value.npilocation;
    this.manageErx.medicareNumber = this.manageerxform.value.medicarnum;
    this.manageErx.specialtyType = this.manageerxform.value.speciality.toString();
    this.manageErx.speciltyCode = this.manageerxform.value.speciality.toString();
    this.manageErx.clinicName = this.manageerxform.value.clname;
    this.manageErx.upin = this.manageerxform.value.upin;
    this.manageErx.standardizedAddressLine1 = this.manageerxform.value.adrsline1;
    this.manageErx.standardizedAddressLine2 = this.manageerxform.value.adrsline2;
    this.manageErx.standardizedCity = this.manageerxform.value.city;
    this.manageErx.standardizedState = this.manageerxform.value.state.replace(/ /g, "");
    this.manageErx.standardizedZip = this.manageerxform.value.zip;
    this.manageErx.email = this.manageerxform.value.email;
    this.manageErx.phonePrimary = this.manageerxform.value.phn;
    this.manageErx.fax = this.manageerxform.value.fax;
    this.manageErx.nadeanNo = this.manageerxform.value.nadeanno;
    //this.manageErx.enableEprescription = this.manageerxform.value.enablepres;
    if (this.manageerxform.value.strtdate != "") {
      var modifiedStartDate = new Date(this.manageerxform.value.strtdate).toISOString();
      this.manageErx.activeStartTime = modifiedStartDate;
    }

    if (this.manageerxform.value.enddate != "") {
      var modifiedEndDate = new Date(this.manageerxform.value.enddate).toISOString();
      this.manageErx.activeEndTime = modifiedEndDate;
    }

    // this.manageErx.activeStartTime ="2020-04-14T15:23:12.215321Z";// this.manageerxform.value.starttime;
    // this.manageErx.activeEndTime ="2050-04-14T15:23:12.215321Z";//this.manageerxform.value.endtime;
    // this.manageErx.endDatetime = this.manageerxform.value.enddate;
    // this.manageErx.endDatetime = this.manageerxform.value.endtime;
    if (this.loadStateList != null && this.loadStateList.length > 0) {
      //   this.manageErx.stateId = this.manageerxform.value.statee;
      // this.manageErx.stateLicenseNumber = this.manageerxform.value.statelnum;
      // this.manageErx.dea = this.manageerxform.value.deanum;
      // this.manageErx.stateQualifier = this.manageerxform.value.rxstatenum;
      //'666576246';
      this.manageErx.dea = this.manageerxform.value.deanum;//'BS4835178';//
    }
    else {
      // this.manageErx.stateId = this.manageerxform.value.statee;
      // this.manageErx.stateLicenseNumber = this.manageerxform.value.statelnum;
      // this.manageErx.dea = this.manageerxform.value.deanum;
      // this.manageErx.stateQualifier = this.manageerxform.value.rxstatenum;
      //this.manageErx.dea =this.loadStateList[0].dea;
    }
    this.manageErx.locationId = this.manageerxform.value.sellocatn;
    this.manageErx.socialSecurity = this.manageerxform.value.SSN;
    // alert(this.manageErx.locationId);
    this.manageErx.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.manageErx.createdOn = new Date().toISOString();
    this.manageErx.activeStatus = 'true';
    this.manageErx.messageId = "DIRPR35672345987";
    this.manageErx.directAddress = ((this.manageerxform.value.rxdirectaddress == '' || this.manageerxform.value.rxdirectaddress == null || this.manageerxform.value.rxdirectaddress == undefined) ? '' :
      this.manageerxform.value.rxdirectaddress.trim() +
      // "@VigiBossMD4Front.direct-ci-cert.com"
      this.messagedomain
    );
    //"senapati.m@VigiBossMD4Front.direct-ci-cert.com"
    // Add State List
    if (this.manageerxform.value.statee !== null && this.manageerxform.value.statee !== '' && this.manageerxform.value.statee !== undefined) {
      var stateName = this.manageerxform.value.statee;
      this.statesData = this.lstStates.filter((state: IStates) => state.stateName === stateName);
      var obj: IStateList = {
        id: 0,
        stateId: this.statesData[0].stateId,
        stateLicNumber: this.manageerxform.value.statelnum,
        stateQualifier: this.manageerxform.value.rxstatenum,
        dea: this.manageerxform.value.deanum,
        userId: this.manageerxform.value.selprovider,
        stateName: this.manageerxform.value.statee,
        isActive: true,
        createdBy: this.manageerxform.value.selprovider,
        createdOn: new Date(),
        modifiedBy: '',
        modifiedOn: null,
        mode: '',
        locationId: Number(this.manageerxform.value.sellocatn)
      };
      this.loadStateList.push(obj);
    }

  }
  clearValues() {
    this.manageerxform.patchValue({
      selprovider: '',
      mname: '',
      lname: '',
      prename: '',
      sufname: '',
      sellevel: '',
      spi: '',
      npinum: '',
      npilocation: '',
      medicarnum: '',
      speciality: '',
      clname: '',
      upin: '',
      adrsline1: '',
      adrsline2: '',
      city: '',
      state: '',
      zip: '',
      zip2: '',
      phn: '',
      fax: '',
      enablepres: '',
      strtdate: '',
      starttime: '',
      enddate: '',
      endtime: '',
      statee: '',
      statelnum: '',
      deanum: '',
      rxstatenum: '',
      sellocatn: '',
      email: '',
      nadeanno: '',
      SSN: '',
    });
  }
  clearStateValues() {
    this.manageerxform.patchValue({
      statee: '',
      statelnum: '',
      deanum: '',
      rxstatenum: '',
    });
  }

  onAddStatelist() {

    var stateName = this.manageerxform.value.statee;
    this.statesData = this.lstStates.filter((state: IStates) => state.stateName === stateName);
    var obj: IStateList = {
      id: 0,
      stateId: this.statesData[0].stateId,
      stateLicNumber: this.manageerxform.value.statelnum,
      stateQualifier: this.manageerxform.value.rxstatenum,
      dea: this.manageerxform.value.deanum,
      userId: this.manageerxform.value.selprovider,
      stateName: this.manageerxform.value.statee,
      isActive: true,
      createdBy: this.manageerxform.value.selprovider,
      createdOn: new Date(),
      modifiedBy: '',
      modifiedOn: null,
      mode: '',
      locationId: 0
    };
    this.loadStateList.push(obj);
    this.dataSources = new MatTableDataSource(this.loadStateList);
    this.statelistDisable = true;
    this.clearStateValues();
  }

  onselectStateQualifer(ele) {
    this.manageerxform.patchValue({
      statee: ele.stateName,
      statelnum: ele.stateLicNumber,
      deanum: ele.dea,
      rxstatenum: ele.stateQualifier,
    });
    this.loadStateList = this.loadStateList.filter(a => a !== ele);
    this.dataSources = new MatTableDataSource(this.loadStateList);
  }

  onDeleteStateQualifer(ele) {
    this.loadStateList = this.loadStateList.filter(a => a !== ele);
    this.dataSources = new MatTableDataSource(this.loadStateList);
    this.statelistDisable = false;
  }


  onLocationChange(locationId, event) {
    if (event.source.selected) {
      this.locationData = this.lstLocations.filter((location: ILocationDetails) => location.locationId === locationId);
    }
  }
  onLocationChangeMain(event) {
    this.locationData = this.lstLocations.filter((location: ILocationDetails) => location.locationId == event.target.value);
    var lstStateCodess = this.lstStates.filter((state: IStates) => state.stateName == this.locationData[0].state);
    console.table(this.locationData)
    if (lstStateCodess.length > 0) {
      this.manageerxform.patchValue({
        state: lstStateCodess[0].stateCode.trim(),
      });
    }
    if (this.locationData.length > 0) {
      this.manageerxform.patchValue({
        npilocation: this.locationData[0].locationName,
        city: this.locationData[0].city,
        zip: this.locationData[0].zip,
        phn: this.locationData[0].phone,
        fax: this.locationData[0].fax,
        adrsline1: this.locationData[0].address1,
        adrsline2: this.locationData[0].address2,
      });
    }
    this.getlocationbasedproviders();
  }
  getlocationbasedproviders() {
    this.sharedService.getselectedlocidByrole("Doctor", Number(this.manageerxform.value.sellocatn)).subscribe(data => {
      this.lstProviders = [];
      this.manageerxform.controls['selprovider'].setValue('');
      this.lstProviders = data;
      this.onProviderChange(null);
    });
  }
  clearLocationdetails() {
    this.manageerxform.patchValue({
      spi: '',
      npilocation: '',
      city: '',
      state: '',
      zip: '',
      phn: '',
      fax: '',
      adrsline1: '',
      adrsline2: '',
    });
  }
  onAddLocationlist() {
    this.loadLocationList.push(this.locationData[0]);
    this.dataSourcess = new MatTableDataSource(this.loadLocationList);
    this.clearLocationdetails();
    this.manageerxform.patchValue({
      sellocatn: '',
    });
    this.locationListDisable = true;
  }
  selectedStateCode: string = "";
  onLocationSelect(element) {

    this.lstStatesCode = this.lstStates.filter(a => a.stateName === element.state);
    if (this.lstStatesCode.length > 0) {
      this.selectedStateCode = this.lstStatesCode[0].stateCode;
      //alert(this.selectedStateCode);
    }
    if (!this.isedit) {
      this.manageerxform.patchValue({
        spi: element.spi,
        npilocation: element.locationName,
        city: element.city,
        state: this.selectedStateCode,
        zip: element.zip,
        phn: element.phone,
        fax: element.fax,
        adrsline1: element.address1,
        adrsline2: element.address2,
        sellocatn: element.locationId
      });
    }
    else {

      var lst = this.lstProviderDirectoryRequestDTO.filter(c => c.locationId == element.locationId);
      if (lst != null && lst.length > 0) {
        this.manageerxform.patchValue({
          //this.MapSSProviderValues(lst);
          mnames: lst[0].firstName,
          lnames: lst[0].lastName,
          prenames: lst[0].prefixName,
          sufnames: lst[0].suffixName,
          sellevels: lst[0].serviceLevel.split(','),//this.levelsArray,
          spi: lst[0].spi,
          spii: lst[0].spi,
          npinumbr: lst[0].npi,
          npilocations: lst[0].npiLocation,
          medicarnumbr: lst[0].medicareNumber,
          specialitys: lst[0].specialtyType.split(','),// this.specialityArray,
          clnames: lst[0].clinicName,
          upinn: lst[0].upin,
          adrslinee1: lst[0].standardizedAddressLine1,
          adrslinee2: lst[0].standardizedAddressLine2,
          cityy: lst[0].standardizedCity,
          states: lst[0].standardizedState,
          zipp: lst[0].standardizedZip,
          phnn: lst[0].phonePrimary,
          faxx: lst[0].fax,
          enableprescrp: '',
          strtdates: lst[0].activeStartTime,
          starttimes: lst[0].activeStartTime,
          enddates: lst[0].activeEndTime,
          endtimes: lst[0].activeEndTime,
          statess: lst[0].state,
          statelnumb: lst[0].stateLicenseNumber,
          deanumb: lst[0].dea,
          rxstatenumb: lst[0].stateQualifier,
          sellocatnn: lst[0].locationId,
          rxdirectaddress: (lst[0].directAddress != "" ? lst[0].directAddress.split('@')[0] : "")
        });
      }
      this.manageerxform.patchValue({
        // spii: element.spi,
        npilocations: element.locationName,
        cityy: element.city,
        states: this.selectedStateCode,
        zipp: element.zip,
        phnn: element.phone,
        faxx: element.fax,
        adrslinee1: element.address1,
        adrslinee2: element.address2,
      });
    }
  }

  onLocationDelete(element) {
    // this.manageerxform.patchValue({
    //   spi: element.spi,
    //  //npinum: element.npi,
    //   npilocation:element.locationName,
    //   city:element.city,
    //   state:element.state,
    //   zip:element.zip,
    //   phn:element.phone,
    //   fax:element.fax,
    //   adrsline1: element.address1,
    //   adrsline2: element.address2,
    // });
    this.loadLocationList = this.loadLocationList.filter(a => a !== element);
    this.dataSourcess = new MatTableDataSource(this.loadLocationList);
    this.manageerxform.patchValue({
      sellocatn: '',
    });
    this.locationListDisable = false;
  }




  result: string;
  serviceCall() {

    this.rxService.sendAddProviderRequestTService(this.irxProviderRequest, this.manageerxform.value.selprovider, 0).subscribe(
      data => {
        this.result = data;
        this.toastr.success(this.result);
        if (this.result.includes("Successfully")) {
          this.getssrequireddata();
          this.show = false;
          this.statelistDisable = false;
          this.locationListDisable = false;
          this.loadStateList.length = 0;
          // if (this.loadStateList.length > 0) {
          //   this.loadStateList.length = 0;
          //   this.dataSources = new MatTableDataSource(this.loadStateList);
          // } else {

          // }
          // if (this.loadLocationList.length > 0) {
          //   this.loadLocationList.length = 0;
          //   this.dataSourcess = new MatTableDataSource(this.loadLocationList);
          // } else {

          // }
        }
      }
    );
  }



  //Existing Provider Logic Starts

  spinumber: string = "";
  levelsArray: string[] = [];
  specialityArray: string[] = [];
  isedit: boolean = false;
  isproviderdisable: boolean = false;
  islocationdisable: boolean = false;
  onClick(element) {
    this.isproviderdisable = true;
    this.islocationdisable = true;
    this.isedit = true;
    this.spinumber = element.spi;
    this.specialityArray.length = 0;
    this.levelsArray.length = 0;
    this.rxService.GetEnabledProvidersInformationTService(this.spinumber).subscribe(data => {
      this.lstProviderDirectoryRequestDTO = data;
      var level = this.lstServiceLevel.filter(a => a.attributeName == element.serviceLevel);
      var speciali = this.lstSpeciality.filter(a => a.attributeName == element.speciality);
      this.MapSSProviderValues(this.lstProviderDirectoryRequestDTO);
      this.onLocationProviderChangeMain(Number(element.locationId));

      this.rxService.GetStatesProviderSSTService(this.lstProviderDirectoryRequestDTO[0].userId, Number(element.locationId)).subscribe(data => {
        this.loadStateListProvider = data;
        if (this.loadStateListProvider.length > 0) {
          this.statelistDisable1 = true;
          this.statesData = this.lstStates.filter((state: IStates) => state.stateId === this.loadStateListProvider[0].stateId);
          this.manageerxform.patchValue({
            statess: this.statesData[0].stateName,
            deanumb: this.loadStateListProvider[0].dea,
            rxstatenumb: this.loadStateListProvider[0].stateQualifier,
            statelnumb: this.loadStateListProvider[0].stateLicNumber,
            sellocatnn: Number(element.locationId),
          });
        }
      });
    });
  }
  onDeleteProviderStateQualifer(ele) {
    this.loadStateListProvider = this.loadStateListProvider.filter(a => a !== ele);
    this.dataSources1 = new MatTableDataSource(this.loadStateListProvider);
    this.statelistDisable1 = false;
  }
  onAddProviderStatelist() {

    var stateName = this.manageerxform.value.statess;
    this.statesData = this.lstStates.filter((state: IStates) => state.stateName === stateName);
    var obj: IStateList = {
      id: 0,
      stateId: this.statesData[0].stateId,
      stateLicNumber: this.manageerxform.value.statelnumb,
      stateQualifier: this.manageerxform.value.rxstatenumb,
      dea: this.manageerxform.value.deanumb,
      userId: this.manageerxform.value.selproviders,
      stateName: this.manageerxform.value.statess,
      isActive: true,
      createdBy: this.manageerxform.value.selproviders,
      createdOn: new Date(),
      modifiedBy: '',
      modifiedOn: null,
      mode: '',
      locationId: 0
    };
    this.loadStateListProvider.push(obj);
    this.dataSources1 = new MatTableDataSource(this.loadStateListProvider);
    this.statelistDisable1 = true;
    this.clearProviderStateValues();
  }
  clearProviderStateValues() {
    this.manageerxform.patchValue({
      statess: '',
      statelnumb: '',
      deanumb: '',
      rxstatenumb: '',
    });
  }
  mapformExistingProviderValues() {
    this.manageErx.userId = this.manageerxform.value.selproviders;
    this.manageErx.firstName = this.manageerxform.value.mnames;
    this.manageErx.middleName = "";
    this.manageErx.lastName = this.manageerxform.value.lnames;
    this.manageErx.prefixName = this.manageerxform.value.prenames;
    this.manageErx.suffixName = this.manageerxform.value.sufnames;
    this.manageErx.serviceLevel = this.manageerxform.value.sellevels.toString();
    this.manageErx.spi = this.manageerxform.value.spii;
    this.manageErx.npi = this.manageerxform.value.npinumbr;
    this.manageErx.npiLocation = this.manageerxform.value.npilocations;
    this.manageErx.medicareNumber = this.manageerxform.value.medicarnumbr;
    this.manageErx.specialtyType = this.manageerxform.value.specialitys.toString();
    this.manageErx.speciltyCode = this.manageerxform.value.specialitys.toString();
    this.manageErx.clinicName = this.manageerxform.value.clnames;
    this.manageErx.upin = this.manageerxform.value.upinn;
    this.manageErx.standardizedAddressLine1 = this.manageerxform.value.adrslinee1;
    this.manageErx.standardizedAddressLine2 = this.manageerxform.value.adrslinee2;
    this.manageErx.standardizedCity = this.manageerxform.value.cityy;
    this.manageErx.standardizedState = this.manageerxform.value.states.replace(/ /g, "");;
    this.manageErx.standardizedZip = this.manageerxform.value.zipp;
    this.manageErx.email = this.manageerxform.value.email;
    if (this.manageerxform.value.phnn != null && this.manageerxform.value.phnn != undefined)
      this.manageErx.phonePrimary = this.manageerxform.value.phnn.replace(/-/g, '');
    if (this.manageerxform.value.faxx != null && this.manageerxform.value.faxx != undefined)
      this.manageErx.fax = this.manageerxform.value.faxx.replace(/-/g, '');
    this.manageErx.nadeanNo = this.manageerxform.value.nadeanno2;
    //alert(this.manageErx.nadeanNo);
    if (this.manageerxform.value.strtdates != "") {
      var modifiedStartDates = new Date(this.manageerxform.value.strtdates).toISOString();
      this.manageErx.activeStartTime = modifiedStartDates;
    }

    if (this.manageerxform.value.enddates != "") {
      var modifiedEndDates = new Date(this.manageerxform.value.enddates).toISOString();
      this.manageErx.activeEndTime = modifiedEndDates;
    }

    if (this.loadStateListProvider != null && this.loadStateListProvider.length > 0) {
      this.manageErx.dea = this.loadStateListProvider[0].dea;
    }
    this.manageErx.stateId = this.manageerxform.value.statess;
    this.manageErx.stateLicenseNumber = this.manageerxform.value.statelnumb;
    this.manageErx.stateQualifier = this.manageerxform.value.rxstatenumb;
    this.manageErx.locationId = this.manageerxform.value.sellocatnn;
    this.manageErx.modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.manageErx.modifiedOn = new Date().toString();
    this.manageErx.activeStatus = 'true';
    this.manageErx.messageId = "DIRPR35672345987";
    this.manageErx.socialSecurity = this.manageerxform.value.SSN2;
    this.manageErx.directAddress = ((this.manageerxform.value.rxdirectaddresss == '' || this.manageerxform.value.rxdirectaddresss == null || this.manageerxform.value.rxdirectaddresss == undefined) ? '' : this.manageerxform.value.rxdirectaddresss.trim() +
      // "@VigiBossMD4Front.direct-ci-cert.com"
      this.messagedomain
    );
    //"senapati.m@VigiBossMD4Front.direct-ci-cert.com";  
    if (this.loadStateListProvider.length == 0) {
      var stateName = this.manageerxform.value.statess;
      this.statesData = this.lstStates.filter((state: IStates) => state.stateName === stateName);
      if (this.statesData != null && this.statesData.length > 0) {
        var obj: IStateList = {
          id: 0,
          stateId: this.statesData[0].stateId,
          stateLicNumber: this.manageerxform.value.statelnumb,
          stateQualifier: this.manageerxform.value.rxstatenumb,
          dea: this.manageerxform.value.deanumb,
          userId: this.manageerxform.value.selproviders,
          stateName: this.manageerxform.value.statess,
          isActive: true,
          createdBy: this.manageerxform.value.selproviders,
          createdOn: new Date(),
          modifiedBy: '',
          modifiedOn: null,
          mode: '',
          locationId: Number(this.manageerxform.value.sellocatnn),
        };
        this.loadStateListProvider.push(obj);
      }
    } else {
      var ids = this.loadStateListProvider[0].id;
      this.loadStateListProvider.length = 0;
      var stateName = this.manageerxform.value.statess;
      this.statesData = this.lstStates.filter((state: IStates) => state.stateName === stateName);
      if (this.statesData != null && this.statesData.length > 0) {
        var obj: IStateList = {
          id: ids,
          stateId: this.statesData[0].stateId,
          stateLicNumber: this.manageerxform.value.statelnumb,
          stateQualifier: this.manageerxform.value.rxstatenumb,
          dea: this.manageerxform.value.deanumb,
          userId: this.manageerxform.value.selproviders,
          stateName: this.manageerxform.value.statess,
          isActive: true,
          createdBy: this.manageerxform.value.selproviders,
          createdOn: new Date(),
          modifiedBy: '',
          modifiedOn: new Date(),
          mode: '',
          locationId: Number(this.manageerxform.value.sellocatnn),
        };
        this.loadStateListProvider.push(obj);
      }
    }
    if (this.loadStateListProvider != null && this.loadStateListProvider.length > 0) {
      this.manageErx.dea = this.loadStateListProvider[0].dea;
    }



    //commented Code
    // this.manageErx.activeStartTime ="2020-04-14T15:23:12.215321Z";// this.manageerxform.value.starttime;
    // this.manageErx.activeEndTime ="2050-04-14T15:23:12.215321Z";//this.manageerxform.value.endtime;
    // this.manageErx.endDatetime = this.manageerxform.value.enddate;
    // this.manageErx.endDatetime = this.manageerxform.value.endtime;
    // this.manageErx.dea = this.manageerxform.value.deanumb;
    //'BS4835178';//
    //this.manageErx.enableEprescription = this.manageerxform.value.enablepres;
    //this.manageErx.serviceLevel ="New";// this.manageerxform.value.sellevel.toString();
    //this.manageerxform.value.mname;
  }

  locationTemp: ILocationDetails[] = [];
  MapSSProviderValues(providerInfo: IProviderDirectoryRequestDTO[]) {
    this.existingProviderLocations.length = 0;
    this.manageerxform.patchValue({
      selproviders: providerInfo[0].userId,
      mnames: providerInfo[0].firstName,
      lnames: providerInfo[0].lastName,
      prenames: providerInfo[0].prefixName,
      sufnames: providerInfo[0].suffixName,
      sellevels: providerInfo[0].serviceLevel.split(','),// this.levelsArray,
      spii: providerInfo[0].spi,
      npinumbr: providerInfo[0].npi,
      npilocations: providerInfo[0].npiLocation,
      medicarnumbr: providerInfo[0].medicareNumber,
      specialitys: providerInfo[0].specialtyType.split(','),//this.specialityArray,
      clnames: providerInfo[0].clinicName,
      upinn: providerInfo[0].upin,
      // adrslinee1: providerInfo[0].standardizedAddressLine1,
      // adrslinee2: providerInfo[0].standardizedAddressLine2,
      // cityy: providerInfo[0].standardizedCity,
      // states: providerInfo[0].standardizedState,
      // zipp: providerInfo[0].standardizedZip,
      // phnn: providerInfo[0].phonePrimary,
      // faxx: providerInfo[0].fax,
      enableprescrp: '',
      strtdates: providerInfo[0].activeStartTime,
      starttimes: providerInfo[0].activeStartTime,
      enddates: providerInfo[0].activeEndTime,
      endtimes: providerInfo[0].activeEndTime,
      statess: providerInfo[0].state,
      statelnumb: providerInfo[0].stateLicenseNumber,
      deanumb: providerInfo[0].dea,
      rxstatenumb: providerInfo[0].stateQualifier,
      sellocatnn: Number(providerInfo[0].locationId),
      SSN2: providerInfo[0].socialSecurity,
      nadeanno2: providerInfo[0].nadeanNo,
      rxdirectaddresss: (providerInfo[0].directAddress != "" ? providerInfo[0].directAddress.split('@')[0] : "")
    });
    if (providerInfo[0].serviceLevel.toLowerCase().includes('new'))
      this.iseRxenabled = "Yes";
    else
      this.iseRxenabled = "No";
    if (providerInfo[0].directAddress != "")
      this.isDMenabled = "Yes";
    else
      this.isDMenabled = "No";
    providerInfo.forEach(element => {
      this.locationTemp = this.lstLocations.filter(a => a.locationId == Number(element.locationId))
      if (this.locationTemp.length > 0) {
        this.locationTemp[0].spi = element.spi;
        this.existingProviderLocations.push(this.locationTemp[0])
      }
      this.locationTemp.length = 0;
    });
    this.dataSourcess2 = new MatTableDataSource(this.existingProviderLocations);
    if (this.existingProviderLocations.length > 0) {
      this.locationListDisable1 = true;
    }
  }

  onLocationProviderChange(locid, event) {
    //if (event.source.selected) {
    this.locationProviderData = this.lstLocations.filter((location: ILocationDetails) => location.locationId === Number(this.manageerxform.value.sellocatnn));
    //}
  }
  onLocationProviderChangeMain(locid) {
    if (locid !== 0 && locid !== null && locid !== undefined) {
      this.locationProviderData = this.lstLocations.filter((location: ILocationDetails) => location.locationId === locid);
      var lstStateCode = this.lstStates.filter((state: IStates) => state.stateName === this.locationProviderData[0].state);
      if (this.locationProviderData.length > 0) {
        this.manageerxform.patchValue({
          adrslinee1: this.locationProviderData[0].address1,
          adrslinee2: this.locationProviderData[0].address2,
          cityy: this.locationProviderData[0].city,
          states: this.locationProviderData[0].state,
          npilocations: this.locationProviderData[0].locationName,
          zipp: this.locationProviderData[0].zip,
          phnn: this.locationProviderData[0].phone,
          faxx: this.locationProviderData[0].fax
        });
        if (lstStateCode.length > 0) {
          this.manageerxform.patchValue({
            states: lstStateCode[0].stateCode.trim(),
          });
        }
      } else {
        this.toastr.error('Selected location is de activated');
      }
    }
  }

  onAddLocationProviderlist() {
    this.existingProviderLocations.push(this.locationProviderData[0]);
    this.dataSourcess2 = new MatTableDataSource(this.existingProviderLocations);
    this.manageerxform.patchValue({
      sellocatnn: '',
    });
    this.locationListDisable1 = true;
  }

  onLocationProviderDelete(element) {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '325px',
      height: '160px',
      data: { headerText: 'Do you want to disable provider for this location ?' }
    });
    dialogRef2.afterClosed().subscribe(dialogResult => {
      if (dialogResult == true) {
        this.rxService.DisableProviderRequestTService(this.lstProviderDirectoryRequestDTO[0].userId, element.spi).subscribe(
          data => {
            this.result = data;
            this.toastr.success(this.result);
            this.locationListDisable1 = false;
          }
        );

        this.existingProviderLocations = this.existingProviderLocations.filter(a => a !== element);
        this.dataSourcess2 = new MatTableDataSource(this.existingProviderLocations);
        this.manageerxform.patchValue({
          sellocatn: '',
        });
      }
      else {
        this.dataSourcess2 = new MatTableDataSource(this.existingProviderLocations);
      }
    });

  }

  onDisableLocation(element) {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '325px',
      height: '160px',
      data: { headerText: 'Do you want to disable provider for this location ?' }
    });
    dialogRef2.afterClosed().subscribe(dialogResult => {
      if (dialogResult == true) {
        this.rxService.DisableProviderRequestTService(this.lstProviderDirectoryRequestDTO[0].userId, element.spi).subscribe(
          data => {
            this.result = data;
            this.toastr.success(this.result);
            this.locationListDisable1 = false;
            this.loadStateListProvider.length = 0;
          }
        );

        this.existingProviderLocations = this.existingProviderLocations.filter(a => a !== element);
        this.dataSourcess2 = new MatTableDataSource(this.existingProviderLocations);
        this.manageerxform.patchValue({
          sellocatn: '',
        });
      }
      else {
        this.dataSourcess2 = new MatTableDataSource(this.existingProviderLocations);
      }
    });
  }
  onCloseLocation(element) {
    if (this.expandedElement === element) {
      this.expandedElement = null;
      this.loadStateListProvider.length = 0;
    }
    this.loadStateListProvider.length = 0;
  }

  onUpdateLocation() {

    this.mapformExistingProviderValues();
    this.irxAddLocationProviderRequest.dddto = this.manageErx;
    this.irxAddLocationProviderRequest.states = this.loadStateListProvider;
    this.serviceCallAddLocation();
  }
  serviceCallAddLocation() {

    this.rxService.sendAddProviderRequestTService(this.irxAddLocationProviderRequest, this.manageerxform.value.selproviders, 2).subscribe(
      data => {
        this.result = data;
        this.toastr.success(this.result);
        this.loadStateListProvider.length = 0;
      }
    );
  }
}